import React, { useState } from 'react';
import { Typography, Tag, Tooltip } from 'antd';
import { CloudDownloadOutlined, SyncOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { dateFromString } from '../../../../utils/dateFromString';
import ModalDescargarDocumentos from './modales/ModalDescargarDocumentos';

const { Text, Link } = Typography;

export default function Informacion({ 
  ordenPago, 
  onDescargarOP, 
  onDescargarDocumento, 
  onDescargarCSF, 
  onDescargarCaratula, 
  onDescargarDocumentoConcesionados, 
  onAjustarCliente,
  onAjustarAnaliticaOdoo,
  loadingAnaliticaOdoo
}) {
  const [showModalDescarga, setShowModalDescarga] = useState(false);

  if (!ordenPago) return null;

  const estatus = ordenPago.estatusOrdenPagoID || 0;

  const getEstatusTag = () => {
    const config = {
      1: { color: 'blue', text: 'Orden Creada' },
      2: { color: 'cyan', text: 'Orden Validada' },
      3: { color: 'orange', text: 'Factura Solicitada' },
      4: { color: 'gold', text: 'Factura Recibida' },
      5: { color: 'purple', text: 'Factura Validada' },
      6: { color: 'lime', text: 'Factura Pagada' },
      7: { color: 'green', text: 'Completada' }
    };
    const c = config[estatus] || { color: 'default', text: 'Desconocido' };
    return <Tag color={c.color}>{c.text}</Tag>;
  };

  return (
    <div>
      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Proveedor</Text>
        </div>
        <div>
          <Text strong>{ordenPago.proveedor}</Text>
        </div>
      </div>

      {ordenPago.razonSocial && (
        <div className="pagos-v2__info-field">
          <div>
            <Text type="secondary">Razón Social</Text>
          </div>
          <div>
            <Text strong>{ordenPago.razonSocial}</Text>
          </div>
        </div>
      )}

      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Tipo</Text>
        </div>
        <div>
          <Text strong>
            {ordenPago.tipoOP === 1 && 'OP Normal'}
            {ordenPago.tipoOP === 2 && 'OP Pago Directo'}
            {ordenPago.tipoOP === 3 && 'OP Concesionado'}
          </Text>
        </div>
      </div>

      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Cliente</Text>
          <Tooltip title="Ajustar cliente">
            <Link onClick={onAjustarCliente} style={{ marginLeft: 8 }}>
              <SyncOutlined />
            </Link>
          </Tooltip>
        </div>
        <div>
          <Text strong>{ordenPago.clienteNombre || '-'}</Text>
        </div>
      </div>

      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Total</Text>
        </div>
        <div>
          <Text strong type="success" style={{ fontSize: 16 }}>{formatCurrency(ordenPago.total)}</Text>
        </div>
      </div>

      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Estatus</Text>
        </div>
        <div>
          {getEstatusTag()}
        </div>
      </div>

      <div className="pagos-v2__info-field">
        <div>
          <Text type="secondary">Fecha Creación</Text>
        </div>
        <div>
          <Text>{dateFromString(ordenPago.fechaCreacion)?.soloFecha || '-'}</Text>
        </div>
      </div>

      <div style={{ flex: 1 }} />

       <div className="pagos-v2__info-field">
         <div>
           <Text type="secondary">Documentos</Text>
         </div>
         <div>
           <Link onClick={() => setShowModalDescarga(true)}>
             <CloudDownloadOutlined />
           </Link>
         </div>
       </div>

       <div className="pagos-v2__info-field">
         <div>
           <Text type="secondary">Analítica Odoo</Text>
           <Tooltip title="Ajustar analítica">
             <Link onClick={onAjustarAnaliticaOdoo} style={{ marginLeft: 8 }} disabled={loadingAnaliticaOdoo}>
               <SyncOutlined spin={loadingAnaliticaOdoo} />
             </Link>
           </Tooltip>
         </div>
         <div>
           {ordenPago.analiticaOdoo && <Text>{ordenPago.analiticaOdoo}</Text>}
         </div>
       </div>

      <ModalDescargarDocumentos
        visible={showModalDescarga}
        onClose={() => setShowModalDescarga(false)}
        ordenPago={ordenPago}
        onDescargarOP={onDescargarOP}
        onDescargarDocumento={onDescargarDocumento}
        onDescargarCSF={onDescargarCSF}
        onDescargarCaratula={onDescargarCaratula}
        onDescargarDocumentoConcesionados={onDescargarDocumentoConcesionados}
      />
    </div>
  );
}
